
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shopify-guides/[slug]",
      function () {
        return require("private-next-pages/shopify-guides/[slug].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shopify-guides/[slug]"])
      });
    }
  